<template>
  <div
    class="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12"
  >
    <div class="w-full max-w-sm">
      <div class="rounded-2xl bg-white p-10 text-center shadow-xl">
        <div
          class="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-red-50"
        >
          <svg
            class="h-10 w-10 text-red-600"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h1 class="text-xl font-semibold text-gray-900">Session Expired</h1>
        <p class="mt-2 text-sm text-gray-500">
          This verification session has expired. Please ask the closing officer
          to generate a new QR code.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({ layout: false })
</script>
